import { render } from "./CompanyPolicyMain.vue?vue&type=template&id=524ee7fc&scoped=true&ts=true"
import script from "./CompanyPolicyMain.vue?vue&type=script&lang=ts"
export * from "./CompanyPolicyMain.vue?vue&type=script&lang=ts"

import "./CompanyPolicyMain.vue?vue&type=style&index=0&id=524ee7fc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524ee7fc"]])

export default __exports__